<template>
  <div :class="className">
    <div class="container-hub__header">
      <slot name="header"></slot>
    </div>
    <div class="container-hub__body">
      <slot name="body"></slot>
    </div>
    <div class="container-hub__footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ContainerHub',
  computed: {
    className () {
      return 'container-hub'
    }
  }
}
</script>

<style lang="scss">
  .container-hub{
    @include media("small-medium"){
      padding: layout("spacing")/2;
    }
    @include media("large"){
      padding: layout("spacing");
    }
    // Header

    &__header{}

    // Body

    &__body{
      padding-top: layout("spacing");

      > *{
        margin-bottom: layout("spacing");
      }
    }

    // Footer

    &__footer{
      @media print {
        display: none !important;
      }
    }
  }
</style>
